document.addEventListener('DOMContentLoaded', function () {
  // --- Canvas Background Animation ---
  const canvas = document.getElementById('jerd-background-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let width, height;
    let circles = [];

    function resize() {
      width = canvas.width = canvas.parentElement.offsetWidth;
      height = canvas.height = canvas.parentElement.offsetHeight;
    }

    function initCircles() {
      circles = [];
      const maxRadius = Math.max(width, height); // Cover full screen
      const count = 80; // Denser circles
      const step = maxRadius / count;

      for (let i = 1; i <= count; i++) {
        const r = i * step;
        
        // Opacity gradient:
        // Start from very low (0.02) at center to higher (0.4) at edges
        // Using power function to make it fade out faster towards center
        const normalizedPos = i / count;
        const opacity = 0.02 + Math.pow(normalizedPos, 1.5) * 0.4;
        
        circles.push({
          r: r,
          baseR: r,
          opacity: opacity,
          speed: 0.002 + (Math.random() * 0.001),
          offset: i * 0.1
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, width, height);
      const centerX = width / 2;
      const centerY = height / 2;
      const time = Date.now() * 0.001;

      circles.forEach(circle => {
        ctx.beginPath();
        // Pulse effect - subtle movement
        const scale = 1 + Math.sin(time * 0.5 + circle.offset) * 0.02;
        const currentR = circle.baseR * scale;
        
        ctx.arc(centerX, centerY, currentR, 0, Math.PI * 2);
        ctx.strokeStyle = `rgba(255, 255, 255, ${circle.opacity})`;
        ctx.lineWidth = 1;
        ctx.stroke();
      });

      requestAnimationFrame(draw);
    }

    window.addEventListener('resize', resize);
    resize();
    initCircles();
    draw();
  }

  // --- Slider Logic ---
  const slider = document.getElementById('items-slider');
  const popup = document.getElementById('range-value-popup');

  if (slider && popup) {
    function updatePopup() {
      const val = slider.value;
      const min = slider.min ? slider.min : 0;
      const max = slider.max ? slider.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      
      popup.innerHTML = val;

      // Calculate position
      // Thumb width is 28px. Center is at 14px.
      // At 0%, left should be 14px.
      // At 100%, left should be calc(100% - 14px).
      // Formula: calc(newVal% + (14 - newVal * 0.28)px)
      popup.style.left = `calc(${newVal}% + (${14 - newVal * 0.28}px))`;
    }

    slider.addEventListener('input', updatePopup);
    // Initialize
    updatePopup();
  }

  // --- Percentage Animation ---
  const percentages = document.querySelectorAll('.percentage');
  
  const observerOptions = {
    threshold: 0.5
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const target = parseInt(el.getAttribute('data-target'));
        animateValue(el, 0, target, 2000);
        observer.unobserve(el);
      }
    });
  }, observerOptions);

  percentages.forEach(p => observer.observe(p));

  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  // --- Form Submission & Variant Logic ---
  const form = document.getElementById('jerd-comparator-form');
  const productDataEl = document.getElementById('jerd-product-data');
  
  if (form && productDataEl) {
    let variants = [];
    try {
      variants = JSON.parse(productDataEl.getAttribute('data-variants'));
    } catch (e) {
      console.error("Error parsing variants:", e);
    }

    // Inputs
    const questionInputs = form.querySelectorAll('input[name="question_amount"]');
    const itemSlider = document.getElementById('items-slider');
    const submitBtn = form.querySelector('button[type="submit"]');

    function getSelectedValues() {
      const questionAmount = Array.from(questionInputs).find(r => r.checked)?.value;
      const itemCount = itemSlider.value;
      return { questionAmount, itemCount };
    }

    function findMatchingVariant() {
      const { questionAmount, itemCount } = getSelectedValues();
      if (!questionAmount || !itemCount) return null;

      // Assuming Option 1 is Question Amount and Option 2 is Item Count
      // We try to match loosely (string comparison)
      return variants.find(v => {
        const opt1 = v.option1 || "";
        const opt2 = v.option2 || "";
        
        // Check exact match or if the option string contains our value
        // e.g. "5-7 Questions" vs "5-7"
        const match1 = opt1 === questionAmount || opt1.includes(questionAmount);
        const match2 = opt2 === itemCount || opt2 === itemCount.toString();
        
        return match1 && match2;
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updatePrice() {
      const variant = findMatchingVariant();
      const priceEl = document.getElementById('jerd-price-display');
      const available = variant && variant.available;

      if (priceEl) {
        priceEl.textContent = available ? formatMoney(variant.price) : "Unavailable";
      }
      if (submitBtn) {
        submitBtn.disabled = !available;
        submitBtn.textContent = available ? "Checkout" : "Unavailable";
      }
    }

    // Listeners for dynamic pricing
    questionInputs.forEach(input => input.addEventListener('change', updatePrice));
    itemSlider.addEventListener('input', updatePrice);
    
    // Initial update
    updatePrice();

    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      // Try to match variant by options, fall back to first available variant
      let variant = findMatchingVariant();
      if (!variant) {
        variant = variants.find(v => v.available);
      }

      if (!variant) {
        alert("Product variant not found. Please check the product setup.");
        return;
      }

      if (!variant.available) {
        alert("This combination is currently unavailable.");
        return;
      }

      const originalText = submitBtn.textContent;
      submitBtn.textContent = "Adding to Cart...";
      submitBtn.disabled = true;

      // Get product info for cart attributes
      const productId = productDataEl.getAttribute('data-product-id') || '';
      const productHandle = productDataEl.getAttribute('data-product-handle') || '';

      try {
        // 1. Clear Cart
        await fetch('/cart/clear.js', {
          method: 'POST'
        });

        // 2. Add to Cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variant.id,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        // 3. Set cart attributes for webhook filtering
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              checkout_source: 'jerd',
              product_id: productId,
              product_handle: productHandle
            }
          })
        });

        // 4. Redirect to checkout
        window.location.href = '/checkout';
      } catch (err) {
        console.error(err);
        alert("There was an error adding to cart. Please try again.");
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    });
  }
});
